import React, { Component } from "react";
import PropTypes from "prop-types";
import {Button, Container, Modal, Text} from "../../../../components";
import {di} from "../../../../bottle";
import styles from "./styles";

export class LanguageChangeWarning extends Component {

    static propTypes = {
        visible: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
        onConfirm: PropTypes.func.isRequired
    };

    static defaultProps = {
        visible: false,
        onClose: () => undefined,
        onConfirm: () => undefined
    };

    render() {

        // resolve inputs
        const { visible, onClose, onConfirm } = this.props;
        const { localization } = di;

        return (
            <Modal visible={visible}
                   onClose={() => undefined}>

                <Text style={styles.title} bold uppercase>
                    {localization.get("build.modals.language.title")}
                </Text>

                <Text style={styles.subtitle}>
                    {localization.get("build.modals.language.subtitle")}
                </Text>

                <Container style={{display: "flex"}}
                           direction="row"
                           justify="space-between"
                           alignContent="space-between">

                    <Button onClick={onClose} style={styles.button}>
                        <Text style={styles.buttonText} bold uppercase>
                            {localization.get("build.modals.language.cancel")}
                        </Text>
                    </Button>

                    <Button onClick={onConfirm} style={styles.button}>
                        <Text style={styles.buttonText} bold uppercase>
                            {localization.get("build.modals.language.continue")}
                        </Text>
                    </Button>
                </Container>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/Customization/components/Modals/LanguageChangeWarning.js